import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Loader {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getStatus() {
        const res = await this.base.get('/api/loader/status');
        const result = res.data;
        return result;
    }
    async syncStatus() {
        const res = await this.base.get('/api/loader/status/sync');
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=loader.js.map